import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { ConfirmationPage as ConfirmationPagePk } from 'omni-package-react-core';

export interface CommunicationPreferencesConfirmationPageProps {
  returnPage: string;
}

const CommunicationPreferencesConfirmationPage: FC<CommunicationPreferencesConfirmationPageProps> = ({ returnPage }) => {
  const { t } = useTranslation('CommunicationPreferencesConfirmationPage');

  return (
    <ConfirmationPagePk title={t('title')} redirect={returnPage}>
    </ConfirmationPagePk>
  );
};
export default CommunicationPreferencesConfirmationPage;
